import { useUser } from "@libs:react-query-auth";
import { Box, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { getFirstCharacter } from "@utils:string";

interface UserMessageProps {
  message: string;
}

export const UserMessage = ({ message }: UserMessageProps) => {
  const currentUser = useUser().data;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "start",
        gap: "0.75rem",
        position: "relative",
      }}
    >
      <Typography
        sx={{
          whiteSpace: "pre-line",
          backgroundColor: "#F9F9FB",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "30px",
          padding: "1rem 2rem",
          borderRadius: "30px",
          textAlign: "right",
          flex: 1,
          wordBreak: "break-word",
        }}
      >
        {message}
      </Typography>
      <Box
        sx={{
          position: "absolute",
          top: "10px",
          right: "-3rem",
        }}
      >
        <Avatar
          sx={{
            width: 40,
            height: 40,
            backgroundColor: "#EEEDF3",
            color: "#161447",
            fontWeight: "600",
          }}
        >
          {getFirstCharacter(currentUser!.email)}
        </Avatar>
      </Box>
    </Box>
  );
};
